import mixpanel from 'mixpanel-browser'

const token = process.env.REACT_APP_MIXPANEL_TOKEN
let enabled = false

const init = () => {
  if (enabled || !token) return
  mixpanel.init(token, {
    persistence: 'localStorage',
    ignore_dnt: false
  })
  enabled = true
}

const identifyUser = user => {
  if (!enabled || !user || !user.id) return
  mixpanel.identify(String(user.id))
  mixpanel.people.set({
    $email: user.email,
    $first_name: user.firstName,
    $last_name: user.lastName,
    role: user.role || null,
    company: user.company || null,
    companyId: user.companyId || null
  })
  if (user.companyId) {
    mixpanel.set_group('company', String(user.companyId))
  }
}

const track = (event, properties = {}) => {
  if (!enabled) return
  mixpanel.track(event, properties)
}

const reset = () => {
  if (!enabled) return
  mixpanel.reset()
}

export default { init, identifyUser, track, reset }
